import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Papa from 'papaparse';
import shortid from 'shortid';

import { Upload, Typography, Space } from 'antd';
import { InboxOutlined } from '@ant-design/icons';

import { selectCurrent, addTransactions } from './uploadSlice';

import styles from './Upload.css';

const { Text } = Typography;

const { Dragger } = Upload;

const proccessBlockfiImport = (rows) => {
  const filtered = rows.filter((row) => {
    return row['action']== 'buy' && row['deposited_currency'] == 'btc';
  });

  return filtered.map((row) => {
    const btcAmount = parseFloat(row['deposited_amount']);
    const fiatAmount = parseFloat(row['withdrawn_amount']);
    const exchangRate = parseFloat(fiatAmount / btcAmount);

    return {
      key: shortid.generate(),
      date: row['inserted_at'].slice(0, -6),
      exchange: 'blockfi',
      btcAmount,
      fiatAmount,
      exchangRate,
    };
  });
};

const proccessKrakenImport = (rows) => {
  const filtered = rows.filter((row) => {
    return row['pair'] == 'XXBTZUSD' && row['type'] == 'buy';
  });

  return filtered.map(row => {
    const fee = parseFloat(row['fee'].slice(2)) ? parseFloat(row['fee']) : 0;
    const btcAmount = parseFloat(row['vol']);
    const fiatAmount = parseFloat(row['cost']);
    const exchangRate = parseFloat(fiatAmount / btcAmount);

    return {
      key: shortid.generate(),
      date: row['time'].split(' ')[0],
      exchange: 'kraken',
      btcAmount,
      fiatAmount,
      exchangRate,
      fee,
    };
  })
};

const proccessAbraImport = (rows) => {
  console.log('ROWS: ', rows)
  const filtered = rows.filter((row) => {
    return row['Transaction type'] == 'Buy' && row['Product'] == 'BTC';
  });

  console.log('filtered: ', filtered);

  return filtered.map(row => {
    const btcAmount = parseFloat(row['Gross Quantity']);
    const fiatAmount = parseFloat(row['Net Amount (USD)']);
    const exchangRate = parseFloat(fiatAmount / btcAmount);

    return {
      key: shortid.generate(),
      date: row['Transaction date (UTC)'].split(' ')[0],
      exchange: 'abra',
      btcAmount,
      fiatAmount,
      exchangRate,
    };
  })
};

const proccessCashImport = (rows) => {
  const filtered = rows.filter((row) => {
    return row['Transaction Type'] == 'Bitcoin Buy';
  });

  return filtered.map(row => {
    const fee = parseFloat(row['Fee'].slice(2)) ? parseFloat(row['Fee'].slice(2)) : 0;
    const btcAmount = parseFloat(row['Asset Amount']);
    const fiatAmount = parseFloat(row['Amount'].slice(2));
    const exchangRate = parseFloat(fiatAmount / btcAmount);

    return {
      key: shortid.generate(),
      date: row['Date'].split(' ')[0],
      exchange: 'cash',
      btcAmount,
      fiatAmount,
      exchangRate,
      fee,
    };
  })
};

const proccessGeminiImport = (rows) => {
  const mappedRows = rows.map(row => {

    if (row['Type'] == 'Buy' && row['Symbol'] == 'BTCUSD') {
      const btcAmount = parseFloat(row['BTC Amount BTC'].split(' ')[0]);
      const fiatAmount = parseFloat(row['USD Amount USD'].replace(/\D/g, '') / 100);
      const fee = parseFloat(row['Fee (USD) USD'].replace(/\D/g, '') / 100);
      const exchangRate = fiatAmount / btcAmount;

      return {
        key: shortid.generate(),
        date: row['Date'],
        exchange: 'gemini',
        btcAmount,
        fiatAmount,
        exchangRate,
        fee,
      };
    }
  });

  return mappedRows.filter(function( element ) {
   return element !== undefined;
  });
};

const proccessCoinbaseImport = (rows) => {
  const filtered = rows.filter((row) => {
    return row['Transaction Type'] == 'Buy';
  });

  return filtered.map((row) => {
    const fee = parseFloat(row['USD Fees'].slice(2))
      ? parseFloat(row['USD Fees'].slice(2))
      : 0;

    const btcAmount = parseFloat(row['Quantity Transacted']);
    const fiatAmount = parseFloat(row['USD Subtotal']);
    const exchangRate = fiatAmount / btcAmount;

    return {
      key: shortid.generate(),
      date: row['Timestamp'].split('T')[0],
      exchange: 'coinbase',
      btcAmount,
      fiatAmount,
      exchangRate,
      fee,
    };
  });
};

const exchangeMapping = {
  cash: proccessCashImport,
  coinbase: proccessCoinbaseImport,
  gemini: proccessGeminiImport,
  blockfi: proccessBlockfiImport,
  kraken: proccessKrakenImport,
  abra: proccessAbraImport,
};

const beforeUpload = (file, exchange, callback) => {

  Papa.parse(file, {
    skipEmptyLines: true,
    encoding: 'utf8 ',
    complete: (results) => {
      const mappedTransactions = exchangeMapping[exchange](results.data);
      callback(addTransactions({ exchange, transactions: mappedTransactions }));
    },
    header: true,
    beforeFirstChunk: (val) => {

      if (exchange == 'coinbase') {
        let headerRowIndex;
        const rows = val.split('\n');

        for (let index = 0; index < rows.length; index++) {
          if (rows[index].split(',')[0] == 'Timestamp') {
            headerRowIndex = index;
            break;
          }
        }

        return rows.slice(headerRowIndex).join('\n');
      } else if (exchange == 'abra') {
        let headerRowIndex;
        const rows = val.split('\n');

        for (let index = 0; index < rows.length; index++) {
          if (rows[index].split(',')[0] == 'Transaction date (UTC)') {
            headerRowIndex = index;
            break;
          }
        }

        return rows.slice(headerRowIndex).join('\n');
      } else {
        return val;
      }
    },
    transform: (val, col) => {
      if (exchange == 'blockfi') {
        return val.replace(/[^0-9a-zA-Z_.-]/gi, '');
      } else {
        return val;
      }
    },
    transformHeader: (val, col) => {
      if (exchange == 'blockfi') {
        return val.replace(/[^0-9a-zA-Z_]/gi, '');
      } else {
        return val;
      }
    },
  });
  // Prevent upload
  return false;
};

export default function Import(props) {
  const dispatch = useDispatch();
  const transactions = useSelector(selectCurrent)

  return (
    <div>
      <div className={styles.container}>
        <Space direction="vertical">
          <Text type="secondary">
            Import transactions from {props.exchange}
          </Text>

          <Dragger
            name="file"
            accept=".csv"
            beforeUpload={(file) =>
              beforeUpload(file, props.exchange, dispatch)
            }
            showUploadList={false}
          >
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-hint">Click or Drag</p>
          </Dragger>
          {transactions[props.exchange] &&
            transactions[props.exchange].length > 0 && (
              <Text type="success">
                Imported{' '}
                {transactions[props.exchange]
                  ? transactions[props.exchange].length
                  : 0}{' '}
                Transactions
              </Text>
            )}
        </Space>
      </div>
    </div>
  );
}
